import { Stack } from '@mui/material';
import {
  BarPlot,
  ChartDataProvider,
  ChartsAxisHighlight,
  ChartsGrid,
  ChartsLegend,
  ChartsReferenceLine,
  ChartsSurface,
  ChartsTooltipContainer,
  ChartsXAxis,
  ChartsYAxis,
} from '@mui/x-charts';
import { chartSetting } from './utils';
import grays from '@legacy/assets/styles/variables/colors/global/grays.module.scss';

import {
  UseChartCartesianAxisParameters,
  UseChartSeriesParameters,
} from '@mui/x-charts/internals';
import { ReactNode } from 'react';

interface BarChartProps {
  widgetName: string;
  parsedWidgetData: any[];
  xAxis: UseChartCartesianAxisParameters['xAxis'];
  yAxis: UseChartCartesianAxisParameters['yAxis'];
  series: UseChartSeriesParameters['series'];
  Tooltip: ReactNode;
  alignment?: string;
}
export const BarChart = ({
  widgetName,
  parsedWidgetData,
  alignment,
  xAxis,
  yAxis,
  series,
  Tooltip,
}: BarChartProps) => {
  return (
    <Stack
      data-automation-id={`ReportingWidgetBarChart-${widgetName}`}
      direction="column"
      alignItems="center"
    >
      <ChartDataProvider
        dataset={parsedWidgetData}
        xAxis={xAxis}
        yAxis={yAxis}
        series={series}
        {...chartSetting(alignment)}
      >
        <ChartsSurface>
          <ChartsGrid vertical />
          <ChartsXAxis />
          <ChartsYAxis />
          <ChartsAxisHighlight x="band" />
          <ChartsReferenceLine
            y={0}
            lineStyle={{ stroke: grays.colorGray30 }}
          />
          <BarPlot />
        </ChartsSurface>
        <ChartsTooltipContainer trigger="axis">
          {Tooltip}
        </ChartsTooltipContainer>

        <ChartsLegend />
      </ChartDataProvider>
    </Stack>
  );
};
